<template>
    <TheOrganizationAddSpace :newSpaceType="spaceTypes.VENDOR_SPACE" spaceTypeIcon="mdi-database"></TheOrganizationAddSpace>
</template>

<script>
import { enumsData } from '@/mixins/enums'
const TheOrganizationAddSpace = () => import('../components/TheHomeAddSpace')

export default {
    mixins: [enumsData],
    components: {
        TheOrganizationAddSpace
    }
}
</script>
